<template>
  <!-- 登录页 -->
  <div>
    <div class="login_wrap" ref="login_wrap" v-load="checkLoading">
      <vue-particles
        color="#fff"
        :particleOpacity="0.7"
        :particlesNumber="60"
        shapeType="circle"
        :particleSize="4"
        linesColor="#fff"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.6"
        :linesDistance="180"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="lizi"
      >
      </vue-particles>

      <div class="login_box" :class="{ loginAn: isLogin, login_left: left }">
        <div class="ms_login" v-if="!checkLoading">
          <div class="ms_title">蓝鹰后台管理系统</div>
          <el-form
            class="ms_content"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
          >
            <el-form-item
              class="ms_content_item"
              :class="{ Tada: nameErr }"
              prop="username"
            >
              <el-input v-model="ruleForm.username" placeholder="请输入用户名">
                <el-button slot="prepend" icon="el-icon-user"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item
              class="ms_content_item"
              :class="{ Tada: pwdErr }"
              prop="password"
            >
              <el-input
                type="password"
                placeholder="请输入密码"
                v-model="ruleForm.password"
                @keyup.enter.native="submitForm('ruleForm')"
              >
                <el-button slot="prepend" icon="el-icon-key"></el-button>
              </el-input>
            </el-form-item>
            <div class="login_btn">
              <el-button
                type="primary"
                :loading="login_loading"
                :disabled="login_loading"
                @click="submitForm('ruleForm')"
                >{{ login_loading ? "登录中..." : "登录" }}</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
      <div
        class="authent"
        :class="{ authent_show: authentShow, authentAn_show: authentAnShow }"
      >
        <div class="loader" style="height: 30px;width: 30px;margin: 0 auto;">
          <div class="loader-inner ball-clip-rotate-multiple">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <p>登陆中...</p>
      </div>
    </div>
    <div class="check_login" v-if="checkLoading">
      <p>正在检查登陆状态...</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg_index: 0,
      timer: null,
      login_loading: false,
      checkLoading: true,
      ruleForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      isLogin: false,
      left: false,
      authentShow: false,
      authentAnShow: false,
      nameErr: false,
      pwdErr: false,
      errTimer: null
    };
  },
  created() {
    let token = localStorage.getItem("token");
    if (token) {
      this.$router.replace("/index");
    } else {
      this.checkLoading = false;
    }
  },
  mounted() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.setBg();
      this.timer = setInterval(() => {
        this.bg_index++;
        if (this.bg_index > 3) {
          this.bg_index = 0;
        }
        this.setBg();
      }, 15000);
      document.title = "登陆";
    }
  },
  methods: {
    setBg() {
      let img = new Image();
      img.src = "static/img/login-bg" + this.bg_index + ".jpg";
      img.onload = () => {
        this.$refs.login_wrap.style.backgroundImage = "url(" + img.src + ")";
      };
    },
    // 显示登陆loading
    loginLoadShow() {
      this.isLogin = true;
      setTimeout(() => {
        this.left = true;
        setTimeout(() => {
          this.authentShow = true;
          setTimeout(() => {
            this.authentAnShow = true;
          }, 50);
        }, 300);
      }, 300);
    },
    // 隐藏登陆loading
    loginLoadHidden() {
      this.authentAnShow = false;
      setTimeout(() => {
        this.authentShow = false;
        setTimeout(() => {
          this.left = false;
          setTimeout(() => {
            this.isLogin = false;
          }, 300);
        }, 50);
      }, 300);
    },
    submitForm(formName) {
      clearTimeout(this.errTimer);
      this.nameErr = false;
      this.pwdErr = false;
      // 表单验证
      if (this.ruleForm.username == "" || this.ruleForm.password == "") {
        if (this.ruleForm.username == "") {
          this.nameErr = true;
          this.errTimer = setTimeout(() => {
            this.nameErr = false;
          }, 1000);
        }
        if (this.ruleForm.password == "") {
          this.pwdErr = true;
          this.errTimer = setTimeout(() => {
            this.pwdErr = false;
          }, 1000);
        }
        this.$refs[formName].validate();
        return;
      }
      this.login_loading = true;
      this.loginLoadShow();
      setTimeout(() => {
        this.$http({
          url: this.$api.login,
          data: {
            loginName: this.ruleForm.username,
            password: this.ruleForm.password
          }
        })
          .then(res => {
            this.login_loading = false;
            this.loginLoadHidden();
            if (res.code == 0) {
              this.$hint("登录成功");
              setTimeout(() => {
                clearInterval(this.timer);
                this.ruleForm.username = "";
                this.ruleForm.password = "";
                localStorage.setItem("token", res.data);
                this.$router.replace("/index");
              }, 1000);
            } else {
              this.$hint(res.message, "err");
            }
          })
          .catch(err => {
            this.$hint(res.message, "err");
          });
      }, 1000);
    }
  }
};
</script>

<style lang="less" scoped>
.login_wrap {
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  perspective: 300px;
  .login_box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    transform-origin: 161px 100%;
    transform: rotateX(0deg);
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    .ms_login {
      width: 450px;
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.5);
      pointer-events: auto;
      .ms_title {
        width: 100%;
        line-height: 60px;
        text-align: center;
        font-size: 26px;
        color: #525f7f;
        font-weight: 700;
        border-bottom: 1px solid #ddd;
      }
      .ms_content {
        padding: 30px 30px;
        box-sizing: border-box;
        .ms_content_item {
          height: 40px;
          /deep/ .el-input__inner {
            height: 45px;
            font-size: 16px;
          }
          /deep/ .el-icon-user {
            font-size: 22px;
          }
          /deep/ .el-icon-key {
            font-size: 22px;
          }
        }
        .login_btn {
          text-align: center;
          > button {
            width: 100%;
            height: 40px;
            margin-bottom: 10px;
            font-size: 16px;
            letter-spacing: 4px;
          }
        }
      }
    }
  }
  .loginAn {
    top: -100px;
    transform: rotateX(50deg) scale(1) !important;
    pointer-events: none;
    .ms_login {
      box-shadow: 0px 20px 30px -10px rgba(0, 0, 0, 0.55);
    }
  }
  .login_left {
    left: -320px !important;
  }
  .authent {
    width: 200px;
    height: 50px;
    box-shadow: 0px 20px 30px -10px rgba(0, 0, 0, 0.55);
    background: rgba(255, 255, 255, 0.3);
    position: absolute;
    top: 90px;
    left: 0;
    right: 50px;
    bottom: 0;
    margin: auto;
    color: #525f7f;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
    padding: 10px 0px;
    border-radius: 4px;
    display: none;
    opacity: 0;
    font-size: 12px;
    transition: all 0.3s;
    .ball-clip-rotate-multiple {
      position: relative;
      left: -8px;
      top: -3px;
      > div {
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        position: absolute;
        left: 0px;
        top: 0px;
        border: 2px solid#525F7F;
        border-bottom-color: transparent;
        border-top-color: transparent;
        border-radius: 100%;
        height: 35px;
        width: 35px;
        -webkit-animation: rotate 1s 0s ease-in-out infinite;
        animation: rotate 1s 0s ease-in-out infinite;
        &:nth-last-child(1) {
          display: inline-block;
          top: 10px;
          left: 10px;
          width: 15px;
          height: 15px;
          -webkit-animation-duration: 0.5s;
          animation-duration: 0.5s;
          border-color: #525f7f transparent #525f7f transparent;
          -webkit-animation-direction: reverse;
          animation-direction: reverse;
        }
      }
    }
    > p {
      margin-top: 7px;
    }
  }
  .authent_show {
    display: block;
  }
  .authentAn_show {
    opacity: 1;
    right: -140px;
  }
}
.check_login {
  color: #666;
  font-size: 13px;
  letter-spacing: 3px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99;
  transform: translateX(-50%) translateY(140%);
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue